import { usePageTitle } from '@calendly/hooks'
import { I18n } from '@calendly/i18n'
import { withSafeSuspense } from '@calendly/safe-suspense'
import { lazy } from 'react'
import { Route, Switch } from 'react-router-dom'

import { useLocalStorageAlerts } from 'hooks/use_local_storage_alerts'

import { Accounts } from './accounts'
import { NewAccounts } from './accounts/new_accounts'

const IcloudConnect = withSafeSuspense(lazy(async () => ({ default: (await import('./icloud_connect')).IcloudConnect })))
const ExchangeConnect = withSafeSuspense(lazy(async () => ({ default: (await import('./exchange_connect')).ExchangeConnect })))
const OutlookDesktopRoutes = withSafeSuspense(lazy(async () => ({ default: (await import('./outlook_desktop')).OutlookDesktopRoutes })))

export const CalendarConnections = ({ match }) => {
  const pageTitle = `${I18n.t('publisher.personal_settings.availability.tabs.connected_calendars')
  } - ${I18n.t('publisher.personal_settings.availability.title')}`

  usePageTitle(pageTitle)
  useLocalStorageAlerts()

  return (
    <Switch>
      <Route path={`${match.url}/icloud/new`} component={IcloudConnect} />
      <Route path={`${match.url}/exchange/new`} component={ExchangeConnect} />
      <Route path={`${match.url}/outlook_desktop`} component={OutlookDesktopRoutes} />
      <Route path={`${match.url}/new`} component={NewAccounts} />
      <Route path={match.url} component={Accounts} />
    </Switch>
  )
}
